import { NumericInput, TextOutput } from 'Components/Core';
import { IWorksheetComponent, WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { AssociatedTestType } from 'Components/Worksheets/Core/WorksheetAssociatedTestSection/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import externalTestMethods from '../../../../ExternalTestMethods';

let AsAssociatedPercentagePassing: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const importedAssociatedPercentagePassingId = useSelector(
    createWorksheetSelector!('AssociatedPercentagePassing.ImportedTest.Id')
  );

  return (
    <>
      <ListFieldSection heading="Original Sample Properties"></ListFieldSection>
      <WorksheetAssociatedTestSection
        heading="Passing 425 µm Determined by:"
        name={`AssociatedPercentagePassing`}
        testType="Sieve Analysis"
        defaultSelection={AssociatedTestType.AutoImported}
        associatedTestModel={{
          autoImported: true,
          imported: {
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} name="PercentPassing" emph />
              </ListFieldSection>
            ),
            importModel: {
              Id: importedAssociatedPercentagePassingId,
            },
          },
          external: {
            testMethods: [
              externalTestMethods.psdSieveAnalysis.AS_1289_3_6_1,
              externalTestMethods.psdSieveAnalysis.AS_1289_3_6_3,
            ],
            permitOtherTestMethods: false,
            externalTestResults: (
              <ListFieldSection>
                <Field
                  input={<NumericInput />}
                  name={`AssociatedPercentagePassing.ExternalTest.Results.PercentagePassing_425_Sieve`}
                />
              </ListFieldSection>
            ),
          },
        }}
      />
    </>
  );
};

AsAssociatedPercentagePassing = withInjectedProps(AsAssociatedPercentagePassing);

export { AsAssociatedPercentagePassing };
export default AsAssociatedPercentagePassing;
